<mat-card class="login-card" *ngIf="isBrowserValid; else unsupported">
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{'main.nav.links.login.shortLabel' | translate}}
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <mat-form-field>
                <mat-icon matPrefix>person</mat-icon>
                <mat-label>{{'auth.login.username.label.shortLabel' | translate}}</mat-label>
                <input type="text" inputmode="email" matInput formControlName="username">
                <mat-error>{{'auth.login.username.errorMessage.summary' | translate}}</mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-icon matPrefix>lock</mat-icon>
                <mat-label>{{'auth.login.password.label.shortLabel' | translate}}</mat-label>
                <input type="password" matInput formControlName="password">
                <mat-hint align="end"><a routerLink="/forgot-password">{{'auth.forgotPassword.summary' | translate}}</a></mat-hint>
                <mat-error>{{'auth.login.password.errorMessage.summary' | translate}}</mat-error>
            </mat-form-field>
            <button *ngIf="!isLoading" type="submit" mat-raised-button color="accent" [disabled]="loginForm.invalid">{{'auth.submit.shortLabel' | translate}}</button>
            <mat-spinner *ngIf="isLoading" [diameter]="35" color="accent" ></mat-spinner>
        </form>
    </mat-card-content>
</mat-card>

<ng-template #unsupported>
    <app-unsupported-browser></app-unsupported-browser>
</ng-template>
